<template>
  <nav
    v-if="data && data.length"
    aria-label="Snabblänkar"
    class="row-1_md-2_lg-4 footer-iconlinks border-line-down"
  >
    <a
      v-for="(link, index) in data"
      :key="link.title + index"
      :href="link.url"
      class="col footer-iconlinks__link-wrapper"
    >
      <no-ssr>
        <svgicon
          :name="link.icon"
          class="footer-iconlinks__icon"
        />
      </no-ssr>
      <div class="footer-iconlinks__content">
        <div
          class="footer-iconlinks__title"
          v-text="link.title"
        />
        <div
          class="footer-iconlinks__text"
          v-text="link.text"
        />
      </div>
    </a>
  </nav>
  <div v-else>
    No icon link list data {{ typeof data }} => {{ data }}
  </div>
</template>

<script>
import baseComponentSettings from "@/vue/components/baseComponentSettings"

export default {
  mixins: [baseComponentSettings]
}
</script>

<style lang="scss">
.footer-iconlinks {
  padding-bottom: 0.625rem;
  margin-bottom: 2rem;

  &[class*="row-"] {
    margin-bottom: 2rem;
  }

  &__icon {
    @include addTransition();

    height: 3rem;
    fill: $color-primary-cta;
    float: left;
    width: 3rem;
    margin-right: 1rem;

    @include media-breakpoint-up(md) {
      margin-right: 0.5rem;
    }
  }

  &__content {
    margin: auto auto auto 0;
  }

  &__title {
    @include font(text, 2, "black");
    @include addTransition();

    color: $color-grey-dark;
    text-decoration: none;
  }

  &__text {
    @include font(rubrik, 1, "light");
    @include addTransition();

    color: $color-grey-dark;
  }

  &__link-wrapper {
    display: flex;
    text-decoration: none;

    &:hover {
      .footer-iconlinks__icon {
        fill: $color-pink-light;
      }

      .footer-iconlinks__title,
      .footer-iconlinks__text {
        color: $color-pink-light;
      }
    }
  }
}
</style>
